import type { EuroCents } from '@shared/domain/euro-cents'
import type { FC } from 'react'

import styled from 'styled-components'

const StyledAmountText = styled.span(
  ({ className, theme }) =>
    className ? theme.variants.paragraph1.regular : theme.variants.body2.regular,
  {
    whiteSpace: 'nowrap',
  },
)

interface FormattedAmountProps {
  value: EuroCents
  ['data-test-id']?: string
  className?: string
}

export const FormattedAmount: FC<FormattedAmountProps> = ({
  value,
  ['data-test-id']: dataTestId,
  className,
}) => {
  return (
    <StyledAmountText className={className} data-test-id={dataTestId}>
      {`${value.format()}`}
    </StyledAmountText>
  )
}
